export default __webpack_public_path__ + "static/media/win.f6d22ddd.png";